import React, { useState } from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import searchIcon from 'utils/icon/icon_search-black.png';
import closeIcon from 'utils/icon/icon_close-black.png';
import { DebounceInput } from 'react-debounce-input';
/**
 * * 인풋 - 검색용
 */

interface IProps {
  id?: string;
  placeholder?: string;
  title?: string;
  disabled?: boolean;
  ref?: any;
  setSearchData?: (e: any) => void | undefined;
}
const SearchInput = ({
  placeholder,
  setSearchData,
  title,
  id,
  disabled = false,
  ref = null,
}: IProps) => {
  const [state, setState] = useState<string>('');

  /// 검색어 입력
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setState(e.target.value);
    if (setSearchData !== undefined) {
      setSearchData(e.target.value);
    }
  };

  const handleClearInput = (): void => {
    setState('');
    if (setSearchData !== undefined) {
      setSearchData('');
    }
  };

  return (
    <Wrapper title={title} id={id}>
      <label htmlFor={id}>{title}</label>
      <SearchIcon>
        <img src={searchIcon} alt='search' />
      </SearchIcon>
      <DebounceInputWrapper
        placeholder={placeholder}
        onChange={onChange}
        value={state}
        debounceTimeout={300}
        disabled={disabled}
      />
      {state.length ? (
        <CloseIcon onClick={handleClearInput}>
          <img src={closeIcon} alt='close' />
        </CloseIcon>
      ) : (
        <></>
      )}
    </Wrapper>
  );
};
export default SearchInput;
const Wrapper = styled.div`
  height: 100%;
  width: 300px;
  position: relative;
  border-radius: 0.4rem;
  label {
    display: ${(props) => (props.title ? 'block' : 'none')};
    color: ${theme.colors.blue_7};
    font-size: ${theme.fontSizes.md};
    margin-left: 0.3rem;
    margin-bottom: 0.2rem;
  }
`;

const SearchIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
`;

const CloseIcon = styled.div`
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  cursor: pointer;
`;

const DebounceInputWrapper = styled(DebounceInput).attrs(
  (props: { disabled: boolean }) => props,
)`
  border: 1px solid ${theme.colors.gray_6};
  padding: 8px 45px !important;
  border-radius: 6px;
  height: 100%;
  &:hover,
  &:focus {
    border: 1px solid
      ${(props) =>
        props.disabled ? theme.colors.gray_6 : theme.colors.blue_focus};
  }
`;
